import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import './index.css';
import './styles/layout.css';
import './styles/text.css';
import './styles/wallet-adapter.css';
import './styles/toast.css';
import './styles/form.css';
import 'react-loading-skeleton/dist/skeleton.css';

import { ToastContainer } from 'react-toastify';
import {
   AccountPage,
   AchievementsPage,
   CompeteAndConnectPage,
   ForgotPasswordPage,
   HomePage,
   MembershipsPage,
   MyEntriesPage,
   MyGamePage,
   PageLayout,
   PassportAndMapPage,
   ReferralCenterPage,
   ResetPasswordPage,
   SignupPage,
   SweepstakesPage,
   TermsAndConditions,
} from './pages';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';

function App() {
   const location = useLocation();

   useEffect(() => {
      ReactGA.send({ hitType: 'pageview', page: location.pathname });
      console.log('location', location.pathname);
   }, [location]);

   return (
      <>
         <Routes>
            <Route
               path="/"
               element={PageLayout({ page: <HomePage />, hero: { enabled: true } })}
            />
            <Route
               path="/account"
               element={PageLayout({ page: <AccountPage />, hero: { enabled: true, title: 'My Account' } })}
            />

            <Route
               path="/signup"
               // element={<SignupPage />}
               element={PageLayout({ page: <SignupPage />, blank: true })}
            />
            <Route
               path="/referral-center"
               element={PageLayout({ page: <ReferralCenterPage />, hero: { enabled: true, title: 'Referral Center' }, smaller: true, requireAuth: true })}
            />
            <Route
               path="/my-entries"
               element={PageLayout({ page: <MyEntriesPage />, hero: { enabled: true, title: 'My Entries' }, smaller: true, requireAuth: true })}
            />
            <Route
               path="/sweepstakes"
               element={PageLayout({ page: <SweepstakesPage />, hero: { enabled: true, title: 'Sweepstakes' }, left: false, smaller: true })}
            />
            <Route
               path="/achievements"
               element={PageLayout({ page: <AchievementsPage />, hero: { enabled: true, title: 'Achievements' }, comingSoon: true })}
            />
            <Route
               path="/passport-and-map"
               element={PageLayout({ page: <PassportAndMapPage />, hero: { enabled: true, title: 'Passport/Map' }, comingSoon: true })}
            />
            <Route
               path="/compete-and-connect"
               element={PageLayout({ page: <CompeteAndConnectPage />, hero: { enabled: true, title: 'Compete/Connect' }, comingSoon: true })}
            />
            <Route
               path="/memberships"
               element={PageLayout({ page: <MembershipsPage />, hero: { enabled: true, title: 'Memberships' }, comingSoon: true })}
            />
            <Route
               path="/my-game"
               element={PageLayout({ page: <MyGamePage />, hero: { enabled: true, title: 'My Game' }, comingSoon: true })}
            />
            <Route
               path="/reset-password"
               element={PageLayout({ page: <ResetPasswordPage />, hero: { enabled: true, title: 'Password Reset' } })}
            />

            <Route
               path="/forgot-password"
               element={PageLayout({ page: <ForgotPasswordPage />, hero: { enabled: true, title: 'Forgot your Password?' } })}
            />
            <Route
               path="/terms-and-conditions"
               element={<TermsAndConditions />}
            />
            <Route
               path="*"
               element={<Navigate to="/" />}
            />
         </Routes>
         <ToastContainer
            position="bottom-left"
            closeOnClick
            theme="dark"
         />
      </>
   );
}

export default App;
